<template>
  <v-select
    :value="selectedLocale"
    @input="$emit('input', $event)"
    :items="langs"
    solo
    class="default-input"
  />
</template>

<script>
import _ from 'lodash';
import UtilsMixins from '@/mixins/UtilsMixins';

export default {
  name: 'SwitchLocale',
  props: {
    value: {
      type: String,
      default: 'en',
    },
    refreshNeeded: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value() {
      this.selectFallbackLocale();
      this.$emit('update:refreshNeeded', true);
    },
  },
  mixins: [UtilsMixins],
  created() {
    this.selectFallbackLocale();
  },
  methods: {
    selectFallbackLocale() {
      const locale = this.langs.find(lang => lang.locales.includes(this.value));
      this.selectedLocale = locale ? locale.value : 'en';
    },
  },
  data() {
    return {
      selectedLocale: 'en',
      langs: [
        {
          text: 'English - en',
          value: 'en',
          locales: [
            'en',
            'en-AU',
            'en-BZ',
            'en-CA',
            'en-CB',
            'en-GB',
            'en-IE',
            'en-JM',
            'en-NZ',
            'en-PH',
            'en-TT',
            'en-US',
            'en-ZA',
            'en-ZW',
          ],
        },
        {
          text: 'Portuguese - Portugues - pt',
          value: 'pt',
          locales: ['pt', 'pt-BR', 'pt-PT'],
        },
        {
          text: 'Hebrew - he',
          value: 'he',
          locales: ['he'],
        },
        {
          text: 'Spanish',
          value: 'es',
          locales: ['es'],
        },
      ],
    };
  },
};
</script>

<style>
select {
  width: 150px;
  line-height: 49px;
  height: 38px;
  font-size: 22px;
  outline: 0;
  margin-bottom: 15px;
}
</style>
